import React from 'react';
import PlaceCard from './PlaceCard';
import './PlaceCard.css';

const PlacesList = ({ places, onCardClick }) => {
    return (
        <div className="places-list">
            {places.map((place) => (
                <PlaceCard key={place.id} place={place} onClick={onCardClick} />
            ))}
        </div>
    );
};

export default PlacesList;
